// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_hu-0";
export var optionCard = "_hu-1";